import * as React from 'react';
import { ComponentProps } from 'react';

import BaseCell from '@websky/core/src/CompareFares/components/FaresSlider/Content/Cell/Cell';
import { FareFeaturePaymentType } from '@websky/graphql';
import { noIcon } from '@websky/core/src/CompareFares/Icons';
import { CdnIcon } from '@websky/core/src/__fsd__/shared/ui';

const availabilityIcons = {
	[FareFeaturePaymentType.Free]: <CdnIcon icon="Info/Item Icluded" />,
	[FareFeaturePaymentType.Pay]: (
		<svg
			className={'icon__pay'}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 12C1 5.928 5.928 1 12 1C18.072 1 23 5.928 23 12C23 18.072 18.072 23 12 23C5.928 23 1 18.072 1 12ZM10.8939 16.9375H13.6375V15.125H10.8939V14.1696H13.5864C14.9724 14.1518 16.0545 13.7857 16.8327 13.0714C17.6109 12.3512 18 11.3601 18 10.0982C18 8.86012 17.591 7.86905 16.773 7.125C15.9551 6.375 14.8616 6 13.4926 6H8.74671V12.3571H7V14.1696H8.74671V15.125H7V16.9375H8.74671V19H10.8939V16.9375ZM13.4586 12.3571H10.8939V7.82143H13.5864C14.2907 7.83929 14.8417 8.05952 15.2393 8.48214C15.6427 8.90476 15.8443 9.4494 15.8443 10.1161C15.8443 10.8601 15.6398 11.4196 15.2308 11.7946C14.8218 12.1696 14.2311 12.3571 13.4586 12.3571Z"
				fill="currentColor"
			/>
		</svg>
	),
	[FareFeaturePaymentType.NotAvailable]: noIcon
};

const Cell: React.FC<ComponentProps<typeof BaseCell>> = props => {
	return <BaseCell customAvailabilityIcons={availabilityIcons} {...props} />;
};

export default Cell;
